import React from 'react';
import { TypedMemo } from '../common/types';
import { RealtimeContext } from './RealtimeContext';
import { useRealtimeSocket } from './useRealtimeSocket';

/**
 * Holds the one realtime socket of the tab and gives its state to the tree. Mount it once, inside
 * the redux store. It opens no socket while the app has no session token.
 */
const RealtimeProviderComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = useRealtimeSocket();
  return <RealtimeContext.Provider value={value}>{children}</RealtimeContext.Provider>;
};

export const RealtimeProvider = TypedMemo(RealtimeProviderComponent);
